import { z } from "zod";

export const SingleEmployeeSchema = z.object({
	label: z.string(),
	value: z.string(),
	showRemove: z.boolean().optional(),
});
